import api from '../../services/api';
import { ORDER_ACTIONS } from '../types/actionTypes';

export const fetchOrders = (page = 1, limit = 10) => async (dispatch) => {
  dispatch({ type: ORDER_ACTIONS.FETCH_ORDERS_REQUEST });
  
  try {
    const response = await api.get(`/inbound/orders?page=${page}&limit=${limit}`);
    console.log('Orders fetched:', response.data);
    
    dispatch({
      type: ORDER_ACTIONS.FETCH_ORDERS_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching orders:', error);
    const message = error.response?.data?.message || 'Failed to fetch orders';
    dispatch({
      type: ORDER_ACTIONS.FETCH_ORDERS_FAILURE,
      payload: message
    });
    throw error;
  }
};

export const fetchOrder = (orderId) => async (dispatch) => {
  dispatch({ type: ORDER_ACTIONS.FETCH_ORDER_REQUEST });
  
  try {
    const response = await api.get(`/inbound/orders/${orderId}`);
    console.log('Order fetched:', response.data);
    
    dispatch({
      type: ORDER_ACTIONS.FETCH_ORDER_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to fetch order';
    dispatch({
      type: ORDER_ACTIONS.FETCH_ORDER_FAILURE,
      payload: message
    });
    throw error;
  }
};

export const assignOrderToLoad = (orderId, loadNumber) => async (dispatch) => {
  dispatch({ type: ORDER_ACTIONS.UPDATE_ORDER_REQUEST });
  
  try {
    console.log(`Assigning order ${orderId} to load ${loadNumber}`);
    const response = await api.put(`/inbound/orders/${orderId}/load/${loadNumber}`);
    console.log('Assignment response:', response.data);
    
    dispatch({
      type: ORDER_ACTIONS.UPDATE_ORDER_SUCCESS,
      payload: response.data
    });
    
    return response.data;
  } catch (error) {
    console.error('Error assigning order to load:', error);
    const message = error.response?.data?.message || 'Failed to assign order to load';
    dispatch({
      type: ORDER_ACTIONS.UPDATE_ORDER_FAILURE,
      payload: message
    });
    throw error;
  }
}; 